import Store from '../Store';
import structure from '../../data/ressources/MarketStores.json';

const MarketStorageStore = new Store('markets/storages', structure);

export {MarketStorageStore};